"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Stores the serialized state of a JSS form before it is POSTed back to the server.
 * Similar API to FormData but supports urlencoded forms (needed for Sitecore antiforgery support),
 * and supports append/get which not all browsers do as of this writing.
 */
var JssFormData = /** @class */function () {
  function JssFormData() {
    this.data = new Array();
  }
  /** Appends a new key/value to the form data. Value will be added to any existing value that may exist. */
  JssFormData.prototype.append = function (key, value) {
    this.data.push({
      key: key,
      value: value
    });
  };
  /** Sets a key/value, removing any existing value(s) set for that key. */
  JssFormData.prototype.set = function (key, value) {
    this.data = this.data.filter(function (entry) {
      return entry.key !== key;
    });
    this.append(key, value);
  };
  /** Merges form data from a client-side state store (i.e. the user-specified values), overwriting any existing values for the keys */
  JssFormData.prototype.mergeOverwritingExisting = function (values) {
    var _this = this;
    Object.keys(values).forEach(function (key) {
      var value = values[key];
      // for multi-valued fields, like checkbox lists,
      // we can receive an array of selected values.
      // we want to _set_ the first one to override anything existing,
      // but _append_ anything after that to avoid overwriting our own values
      if (Array.isArray(value)) {
        value.forEach(function (v, index) {
          if (index === 0) {
            _this.set(key, v);
          } else {
            _this.append(key, v);
          }
        });
      } else {
        _this.set(key, value.toString());
      }
    });
  };
  /** Gets all key/values in the store. Duplicate keys with different values are possible. */
  JssFormData.prototype.get = function () {
    return __spreadArrays(this.data);
  };
  /**
   * Converts the store into a FormData that can be POST-ed with fetch as multipart/form-data.
   */
  JssFormData.prototype.toMultipartFormData = function () {
    var formData = new FormData();
    this.data.forEach(function (entry) {
      return formData.append(entry.key, entry.value);
    });
    return formData;
  };
  /**
   * Converts the store into a URL-encoded string suitable to POST as application/x-www-form-urlencoded.
   */
  JssFormData.prototype.toUrlEncodedFormData = function () {
    return this.data.map(function (entry) {
      return encodeURIComponent(entry.key) + "=" + encodeURIComponent(entry.value.toString());
    }).join('&').replace(/%20/g, '+');
  };
  return JssFormData;
}();
exports.JssFormData = JssFormData;